import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import '../colors/variables.module.css';
import '../colors/constant/variables.module.css';
import * as React from 'react';
import { UiKitContextProvider } from '../context';
/**
 * Эта компонента обязательно должна быть в корне приложения
 *
 * Без неё кит может не работать
 */
export function UiKitRoot(_ref) {
  var children = _ref.children,
    contextProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(UiKitContextProvider, contextProps, /*#__PURE__*/React.createElement("div", null, children));
}